import OrgScopedPage from "./OrgScopedPage";
import Channels from "../Channels/Channels";

/**
 * PlatformChannels — super-admin Channels page. Reuses the exact tenant Channels
 * UI (channel integrations + embeddable widget keys / SDK generator) scoped to
 * the selected organization.
 */
export default function PlatformChannels() {
    return (
        <OrgScopedPage title="Channels" subtitle="Manage an organization's channels and embeddable widget / SDK.">
            <Channels />
        </OrgScopedPage>
    );
}
